import api from './api';
import { ENDPOINTS } from './endpoints';

/**
 * Fetch all available substances from the backend
 * @returns {Promise<Array>} Array of substance objects
 */
export async function fetchSubstances() {
  const { data: envelope } = await api.get(ENDPOINTS.SUBSTANCES.LIST);
  const substances = envelope?.data || [];
  return substances;
}

/**
 * Submit prescription data to backend
 * @param {Object} prescriptionData - The prescription form data
 * @returns {Promise<Object>} Response from backend
 */
export async function submitPrescription(prescriptionData) {
  const response = await api.post(
    ENDPOINTS.PRESCRIPTION.SUBMIT,
    prescriptionData
  );
  const responseData = response.data?.data || response.data || {};
  return responseData;
}

/**
 * Update prescription data to backend
 * @param {Object} prescriptionData - The prescription form data with order_id
 * @returns {Promise<Object>} Response from backend
 */
export async function updatePrescription(prescriptionData) {
  const response = await api.patch(
    ENDPOINTS.PRESCRIPTION.UPDATE,
    prescriptionData
  );
  const responseData = response.data?.data || response.data || {};
  return responseData;
}

/**
 * Search for a product based on prescription data
 * @param {Object} productData - The prescription item data (substance, dosage, form, frequency, days)
 * @returns {Promise<Object>} Response from backend
 */
export async function searchProduct(productData) {
  try {
    const response = await api.post(
      ENDPOINTS.PRESCRIPTION.SEARCH_PRODUCT,
      productData
    );
    return response.data || {};
  } catch (error) {
    if (error.response?.data) {
      const errorData = error.response.data;
      if (errorData.error) {
        return { error: errorData.error };
      }
      if (errorData.message) {
        return { message: errorData.message };
      }
      return errorData;
    }
    throw error;
  }
}

export default {
  fetchSubstances,
  submitPrescription,
  updatePrescription,
  searchProduct,
};
